import { PropsWithChildren } from 'react';
import { Tooltip } from '@mui/material';

export const TooltipWrapper = ({
  tooltip,
  children,
}: PropsWithChildren<{ tooltip?: string | string[] }>) => {
  if (!tooltip) return children;

  return (
    <Tooltip
      title={<TooltipRender tooltip={tooltip} />}
      placement="bottom-start"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'black',
            color: 'white',
            fontSize: '12px',
            fontWeight: 500,
            fontFamily: 'inherit',
            padding: '4px 8px',
          },
        },
      }}
    >
      <div>{children}</div>
    </Tooltip>
  );
};

const TooltipRender = ({ tooltip }: { tooltip?: string | string[] }) => {
  if (!Array.isArray(tooltip)) return tooltip;

  return (
    <div>
      {tooltip.map((title) => (
        <p key={title}>{title}</p>
      ))}
    </div>
  );
};
